export default {
    // 学生学业规划内容
    message: {
        getStudentExistInfo:  '/customer/getStudentExistInfo',//返回学生已填写的信息
        storeStudentCensusQuestion:  '/customer/storeStudentCensusQuestion',//学生-添加、编辑问卷信息
        detailStudentCensusQuestion:  '/customer/detailStudentCensusQuestion',//学生-查看问卷
        detailStudentInfo:  '/customer/detailStudentInfo',//学生-个人中心 - 详情
        modifyPassword: '/customer/modifyPassword',//学生-个人中心 - 编辑
        storeNotFirstStudentCensusQuestion:'/customer/storeNotFirstStudentCensusQuestion', //编辑学生问卷保存
        getStudentSchedule:'/customer/getStudentSchedule' , // 第一次学生信息调详情
    },
    student: {
        //学生信息
        studentMessage: {
            grade: {
                getAchievementListByStudent:  '/customer/getAchievementListByStudent',//学生查看学生成绩 - 列表
                detailAchievementByStudent: '/customer/detailAchievementByStudent',//学生查看学生成绩 - 详情入参列表是主键id
            },
            competition: {
                getCompetitionInfoListByStudent: '/customer/getCompetitionInfoListByStudent',//学生信息 - 竞赛信息列表
                detailCompetitionInfoByStudent: '/customer/detailCompetitionInfoByStudent',//学生信息 - 入参是列表的主键id
            },
            quality: {
                getComplexQualityListByStudent: '/customer/getComplexQualityListByStudent',//学生信息 - 综合素质信息列表
                detailComplexQualityByStudent: '/customer/detailComplexQualityByStudent',//学生信息 - 综合素质信息详情
            },
            studentQues: {
                getStudentCensusQuestionByStudent: '/customer/getStudentCensusQuestionByStudent',//学生信息 - 学生问卷展示
            },
            parentQues: {
                getParentCensusQuestionByStudent: '/customer/getParentCensusQuestionByStudent',//学生信息 - 家长问卷展示
            },
            careerReport: {
                getCareerReportIdByStudentIdByStudent: '/customer/getCareerReportIdByStudentIdByStudent',//学生查看学生生涯测评-获取生涯测评报告id
                getPartBDetailByStudent: '/customer/getPartBDetailByStudent',//学生查看学生测评报告解读-获取partB
                getPartADetailByStudent: '/customer/getPartADetailByStudent ',//学生查看学生测评报告解读-获取partA
                getStudentAndParentInfoByStudent:'/customer/getStudentAndParentInfoByStudent'
            }
        },
        // 规划内容
        planningContent: {
            getPlanListByStudent: '/customer/getPlanListByStudent',//学生查看学生规划内容 - 列表
            getPlanByIdByStudent: '/customer/getPlanByIdByStudent',//学生查看学生规划内容 - 详情
            adjustPlanComparedByStudent: '/customer/adjustPlanComparedByStudent',//学生查看学生规划内容 - 详情
        },
        // 计划执行
        implement: {
            getTargetSplitListByStudent: '/customer/getTargetSplitListByStudent',//学生查看学生-计划执行-目标拆分 - 列表
            getTargetSplitDetailByIdByStudent: '/customer/getTargetSplitDetailByIdByStudent',//学生查看学生-计划执行-目标拆分 - 详情

            getCurrentSemesterByStudentIdByStudent: '/customer/getCurrentSemesterByStudentIdByStudent',//学生查看学生 - 计划执行 - 行动计划 - 列表
            getActionPlanListByStudent: '/customer/getActionPlanListByStudent',//学生查看学生 - 计划执行 - 行动计划 - 列表
            getActionPlanDetailByStudent: '/customer/getActionPlanDetailByStudent',//学生查看学生 - 计划执行 - 行动计划 - 详情
            getCurrentSemesterConditionalGoals:'/customer/getCurrentSemesterConditionalGoalsByStudent',//更新最后一次 当前学期的条件目标



            getStageAssessListByStudent: '/customer/getStageAssessListByStudent',// 学生查看学生 - 计划执行 - 阶段评估 - 列表
            getStageAssessDetailByStudent: '/customer/getStageAssessDetailByStudent',//学生查看学生 - 计划执行 - 阶段评估 - 详情
        },
        // 咨询记录
        consultationRecord: {
            getStudentInterviewListByStudent: '/customer/getStudentInterviewListByStudent',//学生查看学生 - 咨询记录 - 学生咨询 - 列表
            getInterviewFreeThemeDetailByStudent: '/customer/getInterviewFreeThemeDetailByStudent',//学生查看学生 - 咨询记录 - 学生咨询 - 详情
            adjustPlanComparedByStudent: '/customer/adjustPlanComparedByStudent',//学生查看学生 - 咨询记录 - 学生咨询 - 列表

            getParentInterviewListByStudent: '/customer/getParentInterviewListByStudent',//家长查看学生 - 咨询记录 - 家长交流 - 列表
            performanceDataAnalysisByStudent: '/customer/performanceDataAnalysisByStudent',//家长查看学生 - 数据分析
        },
        growth:{
            getLastGrowthFileIdByStudent: '/customer/getLastGrowthFileIdByStudent',//家长查看学生 - 成长档案 - 返回最新一条成长档案id
            getGrowthFileDetailByStudent: '/customer/getGrowthFileDetailByStudent',//家长查看学生 - 成长档案 - 查看档案
            getStudentDataByStudentIdByStudent: '/customer/getStudentDataByStudentIdByStudent',//家长查看学生 - 成长档案 - 查看档案
        },
        //数据分析
        dataAnalysis:{
            actionPlan:'/customer/actionPlanDataAnalysisByStudent',//行动计划 ..
            grade:'/customer/performanceDataAnalysisByStudent'//成绩 ..
        }
    }

}
